module.exports = __webpack_public_path__ + "videos/optimised/d13e1f08318b19f161d76b7d9b22bbfc.mp4";